/**
 * Placeholder data for restricted visitor context (free users)
 * These values are shown blurred to entice users to upgrade
 */

export const PLACEHOLDER_VISITOR_METADATA = {
	// Profile
	name: 'Sarah Johnson',
	email: 'sarah.j@example.com',

	// Browser & Technical
	browser_name: 'Chrome',
	browser_version: '120.0',
	os_name: 'macOS',
	os_version: '14.1',
	device_type: 'desktop' as const,

	// Screen
	screen_width: 1920,
	screen_height: 1080,

	// Page Context
	current_page_url: 'https://example.com/pricing',
	page_title: 'Pricing Plans - Example',

	// User Preferences
	timezone: 'America/Los_Angeles',
	language: 'English (US)',

	// Location (Pro features)
	city: 'San Francisco',
	region: 'California',
	country_code: 'US',
}
